import * as actions_admin from 'actions/admin-actions';
import Gallery from "react-photo-gallery";
import React, { useEffect } from 'react';
import { imageSize } from 'components/common/toolbox';
import { useDispatch, useSelector } from 'react-redux'

const AttachmentGallery = (props) => {

    const dispatch = useDispatch();
    const admin = useSelector((store) => store.admin);

    useEffect(() => {
		return () => {
            dispatch(actions_admin.lightboxIndex(0)); // reset to 0 when closed
		};
	}, []);

    const imageRenderer = (params) => {
        if (params.key.includes('.pdf'))  {
            return (
                <div className="flex-grow-1 text-center">
                    <object data={ params.key } type="application/pdf" className="p-2" frameBorder="0" width="100%" height="300px">
                        <div className="m-2 p-5" width="50%" style={{ border: '1px solid #cccccc' }}>
                            <h2> <i className="fa-solid fa-file-pdf fa-3x text-muted"></i></h2> 
                        </div>
                    </object>
                    <a href={ params.key } target="_blank">Open in Browser</a>
                </div>
            );
        } else {
            return (
                <div className="position-relative" role="button" onClick={ () => props.toggleLightbox(props.attachIndex, params.index)}>
                    <img className="p-1" src={ params.photo.src } height={ params.photo.height } width={ params.photo.width } />
                    <div className="mx-1 p-1 text-center" style={{ backgroundColor: '#eeeeee' }}>
                        <p className="m-0">{params.photo?.caption}</p>
                    </div>
                </div>
            )
        }
    }
    const galleryImages = props.photos.map((entry) => {
        return ({
            src: imageSize(entry.imageUrl, 'md'),
            imageUrl: imageSize(entry.imageUrl, 'md'),
            width: entry.dimensions?.width ?? 4,
            height: entry.dimensions?.height ?? 3,
            caption: entry.caption,
        });
    });

    return (
        <div className="p-1 mb-3"style={{ border: '1px solid #dddddd' }}>
            <Gallery photos={galleryImages} renderImage={imageRenderer} />
            <p className="pl-1 m-0">{props.name}</p>
        </div>
    );
};

export default AttachmentGallery;